"use strict";

var BaseSearchPaging = require("./BaseSearchPaging");

var SearchPaging = React.createClass({
	propTypes: {
		isDesignMode: React.PropTypes.bool,
		dataChildOf: React.PropTypes.string,
		theme: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		dataRepeatedId: React.PropTypes.string,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,

		numberPagesToShow: React.PropTypes.number,
		includeFirstPageNumber: React.PropTypes.bool,
		includeLastPageNumber: React.PropTypes.bool,
		currentPageNumber: React.PropTypes.number,
		pageSize: React.PropTypes.number,
		totalCount: React.PropTypes.number
	},

	handlePageChange: function(pageNumber) {
		var $searchResultsComponent = $(ReactDOM.findDOMNode(this)).closest("[data-component=searchResults]");
		search($searchResultsComponent.attr("id"), pageNumber);
	},

	render: function () {
		return (
			<BaseSearchPaging
				{...this.props}
				thisArg={this}
				className="search-paging"
				previousPageSelector={`[data-component="searchResults.populated.paging.previousPage"]`}
				nextPageSelector={`[data-component="searchResults.populated.paging.nextPage"]`}
				onPageChange={this.handlePageChange}
				dataReactComponentName="SearchPaging"
				dataReactComponentCategory="SearchPagingComponents"
			/>
		);
	}
});

module.exports = SearchPaging;



// WEBPACK FOOTER //
// ./Javascript/searchComponents/SearchPaging.jsx